import {
    atomWithStorage as atomWithStorageGeneric,
    createJSONStorage,
} from 'jotai/utils';
import type { SyncStringStorage } from 'jotai/vanilla/utils/atomWithStorage';
import { createContext, useContext } from 'react';

import type { StorageKeys } from '../constants';
import type { ContainerComponent } from '../types/Common';
import type { IStorage } from '../types/Storage';
import StorageFacade from './StorageFacade';

const StorageContext = createContext(StorageFacade);

export const useStorage = (): IStorage => {
    return useContext(StorageContext);
};

export function atomWithStorage<T>(
    key: StorageKeys,
    initialValue: T,
    getOnInit: boolean = true,
) {
    return atomWithStorageGeneric<T>(
        key,
        initialValue,
        createJSONStorage<T>(() => JotaiStorageAdapter),
        { getOnInit },
    );
}

export const StorageProvider: ContainerComponent = ({ children }) => {
    return (
        <StorageContext.Provider value={StorageFacade}>
            {children}
        </StorageContext.Provider>
    );
};

export const JotaiStorageAdapter: SyncStringStorage = {
    getItem: (key: string) => {
        return StorageFacade.getString(key) ?? null;
    },
    setItem: (key: string, value: string) => {
        StorageFacade.setString(key, value);
    },
    removeItem: (key: string) => {
        StorageFacade.removeItem(key);
    },
};
